import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { shallowEqual, useSelector } from "react-redux";
import { alertError, alertSuccess } from "../../../utils/logger";
import LoadingDialog from "./LoadingDialog";
import { postPartida } from "../../../api/partida";

function getEmptyPlantillaPartida() {
  return {
    referencia: null,
    descripcion: null,
    categoria_id: null,
    concepto: null,
    productos: [],
  };
}

function simplifyObject(input) {
  return {
    referencia: input.referencia,
    descripcion: input.descripcion,
    categoria_id: input.categoria_id,
    concepto: input.concepto,
    productos: input.productos.map((producto) => ({
      producto_id: producto.plantilla_producto_original_id,
      unidades: producto.def_unidades || 1,
    })),
  };
}

const GuardarPlantillaPartidaDialog = (props) => {
  const { title, open, setOpen, data, onSave } = props;

  const [loading, setLoading] = useState(false);

  const [plantillaPartida, setPlantillaPartida] = useState({
    ...getEmptyPlantillaPartida(),
    ...simplifyObject(data),
  });

  useEffect(() => {
    if (open)
      setPlantillaPartida({
        ...getEmptyPlantillaPartida(),
        ...simplifyObject(data),
      });
  }, [open]);

  const loggedUser = useSelector(
    (store) => store.authentication?.user,
    shallowEqual
  );

  function savePartida() {
    const validatePartida = () => {
      let error = "";

      if (!plantillaPartida?.referencia) {
        error = "La referencia es obligatoria.";
      }

      if (error) {
        alertError({
          error: error,
        });
        return false;
      }

      return true;
    };

    if (!validatePartida()) {
      return;
    }
    postPartida(plantillaPartida, loggedUser?.accessToken)
      .then((res) => {
        if (res.status === 201) {
          alertSuccess({
            title: "¡Guardada!",
            customMessage: "Partida guardada con éxito.",
          });
          setOpen(false);
          setPlantillaPartida(getEmptyPlantillaPartida());
        }
      })
      .catch((error) => {
        alertError({
          error: error,
          customMessage: "No se ha podido guardar la partida.",
        });
      });
  }

  const handleChange = (element) => (event) => {
    setPlantillaPartida({ ...plantillaPartida, [element]: event.target.value });
  };

  return (
    <>
      <Dialog
        fullWidth={true}
        maxWidth="md"
        open={open}
        onClose={() => {
          setOpen(false);
        }}
        aria-labelledby="table-dialog"
        className="backdrop"
      >
        <DialogTitle id="table-dialog">{title}</DialogTitle>
        <DialogContent>
          <div className="row d-flex align-items-center">
            <div className="col-md-6">
              <TextField
                label="Referencia"
                value={plantillaPartida.referencia}
                onChange={handleChange("referencia")}
                InputLabelProps={{
                  shrink: true,
                }}
                margin="normal"
                variant="outlined"
                required
              />
            </div>
          </div>
        </DialogContent>
        <DialogActions>
          <Button
            className="mr-2"
            onClick={() => {
              setOpen(false);
              setPlantillaPartida(getEmptyPlantillaPartida());
            }}
            variant="outlined"
          >
            Cancelar
          </Button>
          <Button
            onClick={() => {
              savePartida();
            }}
            variant="outlined"
            color="primary"
          >
            Guardar
          </Button>
          <br />
        </DialogActions>
      </Dialog>
      <LoadingDialog open={loading} />
    </>
  );
};
export default GuardarPlantillaPartidaDialog;
